<template>
  <div class="editTranslate">
    <h4 class="person-prompt" v-show="personLine != 0">
      前面有人，正在翻译
      <!-- {{ personLine }} -->
    </h4>
    <i
      class="el-icon-sort-down"
      @click="choiceType"
      :class="choice == false ? 'blue' : ''"
    >
    </i>
    <i
      class="el-icon-sort-up"
      @click="choiceType"
      :class="choice == true ? 'blue' : ''"
    ></i>
    <span @click="getTranslate" v-show="choice == false" v-preventReClick
      >中译英</span
    >
    <span @click="getTranslate" v-show="choice == true" v-preventReClick
      >英译中</span
    >

    <div class="allTemplate" v-show="findTemplate">
      <!-- 中间提示框 -->
      <div class="allTemplate-prompt">
        <span>{{ msgTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { translate } from "./graphql/translate.gql";
export default {
  props: { translateWord: String, translateEnglishWord:String},
  data() {
    return {
      choice: false,
      personLine: 0,
      // 模态框
      findTemplate: false,
      // 提示框
      msgTitle: "正在翻译中，请不要点击其他地方",
      // flag: "1"
    };
  },
  methods: {
    getTranslate() {
      // console.log(this.translateWord)
      if(this.choice==false){
        this.translateWord = this.translateWord.replace(
        /\&nbsp;|\&quot;|\&#39;/g,
        ""
      );
      }else{
          this.translateEnglishWord = this.translateEnglishWord.replace(
        /\&nbsp;|\&quot;|\&#39;/g,
        ""
      );
      }
      (this.msgTitle = "正在翻译中，请不要点击其他地方"),
        (this.findTemplate = true);
      this.$global
        .GraphqlMutation(this, translate, {
          data: this.choice ? this.translateEnglishWord:this.translateWord,
          flag: this.choice ? "2":"1"
        })
        .then(res => {
          if (res.data == "loading") {
            this.msgTitle = "前面有用户再使用";
            this.personLine = 1;
            setTimeout(() => {
              this.findTemplate = false;
            }, 2000);
          } else if (res.data == "flag error") {
            this.msgTitle = "请选择正确的中译英或者英译中";
            setTimeout(() => {
              this.findTemplate = false;
            }, 2000);
          } else {
            this.$emit("returnTranslate", res.data,this.choice ? "2":"1");
            this.findTemplate = false;
            this.personLine = 0;
          }
          // this.$emit("returnTranslate", res.data);
        })
        .catch(err => {
          this.msgTitle = "出现异常了";
          setTimeout(() => {
            this.findTemplate = false;
          }, 2000);
        });
    },
    choiceType() {
      // this.choice = (this.choice == false) == true ? true : false;
      this.choice = !this.choice;
      
    }
  }
};
</script>
<style lang="scss" scoped>
.editTranslate {
  display: flex;
  justify-content: flex-end;
  margin: 35px 0;
  position: relative;
  .person-prompt {
    position: absolute;
    right: 140px;
    top: 5px;
  }
  .el-icon-sort-down {
    position: absolute;
    right: 100px;
    top: 1px;
    font-size: 30px;
    border-radius: 4px;
    color: $border-color;
  }
  .el-icon-sort-up {
    position: absolute;
    color: $border-color;

    border-radius: 4px;
    right: 85px;
    top: 0;
    font-size: 30px;
  }
  .blue {
    color: $blueBtna;
  }
  > span {
    background: $blueBtna;
    padding: 6px 15px 5px 17px;
    color: $base-color;
    font-size: 16px;
    border-radius: 15px;
  }
  .allTemplate {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    .allTemplate-prompt {
      display: flex;
      justify-content: center;
      align-self: center;
      cursor: pointer;
      background: $base-color;
      width: 30%;
      height: 200px;
      border-radius: 6px;
      span {
        align-self: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/template/TranslateText.vue